import { createReducer } from 'redux-act';
import actions from '../actions/communityActions';

const initialState = {
    sidebarOptions: { minimize: false, show: 'responsive' },
    messageNotification: null,

    createPostPending: false,
    createPostRes: null,
    createPostError: null,

    updatePostPending: false,
    updatePostRes: null,
    updatePostError: null,

    deletePostPending: false,
    deletePostRes: null,
    deletePostError: null,

    getAllPostPending: false,
    getAllPostRes: null,
    getAllPostError: null,

    postLikePending: false,
    postLikeRes: null,
    postLikeError: null,

    postLikeByIdPending: false,
    postLikeByIdRes: null,
    postLikeByIdError: null,

    postCommentPending: false,
    postCommentRes: null,
    postCommentError: null,

    getCommentByIdPending: false,
    getCommentByIdRes: null,
    getCommentByIdError: null,

    deleteCommentPending: false,
    deleteCommentRes: null,
    deleteCommentError: null,

    updateCommentPending: false,
    updateCommentRes: null,
    updateCommentError: null,

    getPostPending: false,
    getPostRes: null,
    getPostError: null,

    getPostCountsPending: false,
    getPostCountsRes: null,
    getPostCountsError: null,

    addAnnouncementPending: false,
    addAnnouncementRes: null,
    addAnnouncementError: null,

    getAnnouncementPending: false,
    getAnnouncementRes: null,
    getAnnouncementError: null,

    updateAnnouncementPending: false,
    updateAnnouncementRes: null,
    updateAnnouncementError: null,

    deleteAnnouncementPending: false,
    deleteAnnouncementRes: null,
    deleteAnnouncementError: null,

    getPopUpAnnouncementPending: false,
    getPopUpAnnouncementRes: null,
    getPopUpAnnouncementError: null,

    getWebcastPending: false,
    getWebcastRes: null,
    getWebcastError: null,

    getAllAnnouncementPending: false,
    getAllAnnouncementRes: null,
    getAllAnnouncementError: null,

    getAlertAnnouncementPending: false,
    getAlertAnnouncementRes: null,
    getAlertAnnouncementError: null,

};


// Create Post REDUCERS
const handleCreatePostRequest = state => {
    return {
        ...state,
        ...{
            createPostPending: true,
            createPostRes: null,
            createPostError: null,
        },
    };
};
const handleCreatePostSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            createPostPending: false,
            createPostRes: payload,
            createPostError: null,
        },
    };
};
const handleCreatePostError = (state, payload) => ({
    ...state,
    ...{
        createPostPending: false,
        createPostRes: null,
        createPostError: payload,
    },
});


// Update Post REDUCERS
const handleUpdatePostRequest = state => {
    return {
        ...state,
        ...{
            updatePostPending: true,
            updatePostRes: null,
            updatePostError: null,
        },
    };
};
const handleUpdatePostSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            updatePostPending: false,
            updatePostRes: payload,
            updatePostError: null,
        },
    };
};
const handleUpdatePostError = (state, payload) => ({
    ...state,
    ...{
        updatePostPending: false,
        updatePostRes: null,
        updatePostError: null,
    },
});

// Delete Post REDUCERS
const handleDeletePostRequest = state => {
    return {
        ...state,
        ...{
            deletePostPending: true,
            deletePostRes: null,
            deletePostError: null,
        },
    };
};
const handleDeletePostSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            deletePostPending: false,
            deletePostRes: payload,
            deletePostError: null,
        },
    };
};
const handleDeletePostError = (state, payload) => ({
    ...state,
    ...{
        deletePostPending: false,
        deletePostRes: null,
        deletePostError: payload,
    },
});

// Get All Post REDUCERS
const handleGetAllPostRequest = state => {
    return {
        ...state,
        ...{
            getAllPostPending: true,
            getAllPostRes: null,
            getAllPostError: null,
        },
    };
};
const handleGetAllPostSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            getAllPostPending: false,
            getAllPostRes: payload,
            getAllPostError: null,
        },
    };
};
const handleGetAllPostPostError = (state, payload) => ({
    ...state,
    ...{
        getAllPostPending: false,
        getAllPostRes: null,
        getAllPostError: payload,
    },
});

// Post Like REDUCERS
const handlePostLikeRequest = state => {
    return {
        ...state,
        ...{
            postLikePending: true,
            postLikeRes: null,
            postLikeError: null,
        },
    };
};
const handlePostLikeSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            postLikePending: false,
            postLikeRes: payload,
            postLikeError: null,
        },
    };
};
const handlePostLikeError = (state, payload) => ({
    ...state,
    ...{
        postLikePending: false,
        postLikeRes: null,
        postLikeError: payload,
    },
});

// get like by id REDUCERS
const handleGetLikeByIdRequest = state => {
    return {
        ...state,
        ...{
            postLikeByIdPending: true,
            postLikeByIdRes: null,
            postLikeByIdError: null,
        },
    };
};
const handleGetLikeByIdSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            postLikeByIdPending: false,
            postLikeByIdRes: payload,
            postLikeByIdError: null,
        },
    };
};
const handleGetLikeByIdError = (state, payload) => ({
    ...state,
    ...{
        postLikeByIdPending: false,
        postLikeByIdRes: null,
        postLikeByIdError: payload,
    },
});

// Post comment REDUCERS
const handlePostCommentRequest = state => {
    return {
        ...state,
        ...{
            postCommentPending: true,
            postCommentRes: null,
            postCommentError: null,
        },
    };
};
const handlePostCommentSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            postCommentPending: false,
            postCommentRes: payload,
            postCommentError: null,
        },
    };
};
const handlePostCommentError = (state, payload) => ({
    ...state,
    ...{
        postCommentPending: false,
        postCommentRes: null,
        postCommentError: payload,
    },
});

// get comment By id REDUCERS
const handleGetCommentByIdRequest = state => {
    return {
        ...state,
        ...{
            getCommentByIdPending: true,
            getCommentByIdRes: null,
            getCommentByIdError: null,
        },
    };
};
const handleGetCommentByIdSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            getCommentByIdPending: false,
            getCommentByIdRes: payload,
            getCommentByIdError: null,
        },
    };
};
const handleGetCommentByIdError = (state, payload) => ({
    ...state,
    ...{
        getCommentByIdPending: false,
        getCommentByIdRes: null,
        getCommentByIdError: payload,
    },
});

// delete comment REDUCERS
const handleDeleteCommentRequest = state => {
    return {
        ...state,
        ...{
            deleteCommentPending: true,
            deleteCommentRes: null,
            deleteCommentError: null,
        },
    };
};
const handleDeleteCommentSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            deleteCommentPending: false,
            deleteCommentRes: payload,
            deleteCommentError: null,
        },
    };
};
const handleDeleteCommentError = (state, payload) => ({
    ...state,
    ...{
        deleteCommentPending: false,
        deleteCommentRes: null,
        deleteCommentError: payload,
    },
});

//Update Comment REDUCERS
const handleUpdateCommentRequest = state => {
    return {
        ...state,
        ...{
            updateCommentPending: true,
            updateCommentRes: null,
            updateCommentError: null,
        },
    };
};
const handleUpdateCommentSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            updateCommentPending: false,
            updateCommentRes: payload,
            updateCommentError: null,
        },
    };
};
const handleUpdateCommentError = (state, payload) => ({
    ...state,
    ...{
        updateCommentPending: false,
        updateCommentRes: null,
        updateCommentError: payload,
    },
});

//get Post REDUCERS
const handleGetPostRequest = state => {
    return {
        ...state,
        ...{
            getPostPending: true,
            getPostRes: null,
            getPostError: null,
        },
    };
};
const handleGetPostSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            getPostPending: false,
            getPostRes: payload,
            getPostError: null,
        },
    };
};
const handleGetPostError = (state, payload) => ({
    ...state,
    ...{
        getPostPending: false,
        getPostRes: null,
        getPostError: payload,
    },
});

//get Post REDUCERS
const handleGetPostCountsRequest = state => {
    return {
        ...state,
        ...{
            getPostCountsPending: true,
            getPostCountsRes: null,
            getPostCountsError: null,
        },
    };
};
const handleGetPostCountsSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            getPostCountsPending: false,
            getPostCountsRes: payload,
            getPostCountsError: null,
        },
    };
};
const handleGetPostCountsError = (state, payload) => ({
    ...state,
    ...{
        getPostCountsPending: false,
        getPostCountsRes: null,
        getPostCountsError: payload,
    },
});


//get Post REDUCERS
const handleGetAnnouncementRequest = state => {
    return {
        ...state,
        ...{
            getAnnouncementPending: true,
            getAnnouncementRes: null,
            getAnnouncementError: null,
        },
    };
};
const handleGetAnnouncementSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            getAnnouncementPending: false,
            getAnnouncementRes: payload,
            getAnnouncementError: null,
        },
    };
};
const handleGetAnnouncementError = (state, payload) => ({
    ...state,
    ...{
        getAnnouncementPending: false,
        getAnnouncementRes: null,
        getAnnouncementError: payload,
    },
});


//Add Announcement REDUCERS
const handleAddAnnouncementRequest = state => {
    return {
        ...state,
        ...{
            addAnnouncementPending: true,
            addAnnouncementRes: null,
            addAnnouncementError: null,
        },
    };
};
const handleAddAnnouncementSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            addAnnouncementPending: false,
            addAnnouncementRes: payload,
            addAnnouncementError: null,
        },
    };
};
const handleAddAnnouncementError = (state, payload) => ({
    ...state,
    ...{
        addAnnouncementPending: false,
        addAnnouncementRes: null,
        addAnnouncementError: payload,
    },
});

/* Update Designation Reducers*/
const handleUpdateAnnouncementRequest = state1 => {
    return {
        ...state1,
        ...{
            updateAnnouncementPending: true,
            updateAnnouncementRes: null,
            updateAnnouncementError: null,
        },
    };
};
const handleUpdateAnnouncementSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            updateAnnouncementPending: false,
            updateAnnouncementRes: payload,
            updateAnnouncementError: null,
        },
    };
};
const handleUpdateAnnouncementError = (state1, payload) => ({
    ...state1,
    ...{
        updateAnnouncementPending: false,
        updateAnnouncementRes: null,
        updateAnnouncementError: payload,
    },
});

/* Delete Designation Reducers*/
const handleDeleteAnnouncementRequest = state1 => {
    return {
        ...state1,
        ...{
            deleteAnnouncementPending: true,
            deleteAnnouncementRes: null,
            deleteAnnouncementError: null,
        },
    };
};
const handleDeleteAnnouncementSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            deleteAnnouncementPending: false,
            deleteAnnouncementRes: payload,
            deleteAnnouncementError: null,
        },
    };
};
const handleDeleteAnnouncementError = (state1, payload) => ({
    ...state1,
    ...{
        deleteAnnouncementPending: false,
        deleteAnnouncementRes: null,
        deleteAnnouncementError: payload,
    },
});

/* Get Pop Up Announcement Reducers*/
const handleGetPopUpAnnouncementRequest = state1 => {
    return {
        ...state1,
        ...{
            getPopUpAnnouncementPending: true,
            getPopUpAnnouncementRes: null,
            getPopUpAnnouncementError: null,
        },
    };
};
const handleGetPopUpAnnouncementSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getPopUpAnnouncementPending: false,
            getPopUpAnnouncementRes: payload,
            getPopUpAnnouncementError: null,
        },
    };
};
const handleGetPopUpAnnouncementError = (state1, payload) => ({
    ...state1,
    ...{
        getPopUpAnnouncementPending: false,
        getPopUpAnnouncementRes: null,
        getPopUpAnnouncementError: payload,
    },
});

/* Get Web Cast Reducers*/
const handleGetWebcastRequest = state1 => {
    return {
        ...state1,
        ...{
            getWebcastPending: true,
            getWebcastRes: null,
            getWebcastError: null,
        },
    };
};
const handleGetWebcastSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getWebcastPending: false,
            getWebcastRes: payload,
            getWebcastError: null,
        },
    };
};
const handleGetWebcastError = (state1, payload) => ({
    ...state1,
    ...{
        getWebcastPending: false,
        getWebcastRes: null,
        getWebcastError: payload,
    },
});


/* get All Announcement Reducers*/
const handleGetAllAnnouncementRequest = state1 => {
    return {
        ...state1,
        ...{
            getAllAnnouncementPending: true,
            getAllAnnouncementRes: null,
            getAllAnnouncementError: null,
        },
    };
};
const handleGetAllAnnouncementSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getAllAnnouncementPending: false,
            getAllAnnouncementRes: payload,
            getAllAnnouncementError: null,
        },
    };
};
const handleGetAllAnnouncementError = (state1, payload) => ({
    ...state1,
    ...{
        getAllAnnouncementPending: false,
        getAllAnnouncementRes: null,
        getAllAnnouncementError: payload,
    },
});


/* get All Announcement Reducers*/
const handleGetAlertAnnouncementRequest = state1 => {
    return {
        ...state1,
        ...{
            getAlertAnnouncementPending: true,
            getAlertAnnouncementRes: null,
            getAlertAnnouncementError: null,
        },
    };
};
const handleGetAlertAnnouncementSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getAlertAnnouncementPending: false,
            getAlertAnnouncementRes: payload,
            getAlertAnnouncementError: null,
        },
    };
};
const handleGetAlertAnnouncementError = (state1, payload) => ({
    ...state1,
    ...{
        getAlertAnnouncementPending: false,
        getAlertAnnouncementRes: null,
        getAlertAnnouncementError: payload,
    },
});


// Clear Existing Data Store Reducers*/
const clearCommunityStore = (state, payload) => {
    switch (payload) {
        case 'HANDLE_CLEAR_CREATE_POST_STORE':
            return {
                ...state,
                ...{
                    createPostPending: false,
                    createPostRes: null,
                    createPostError: null,
                },
            };
        case 'HANDLE_CLEAR_UPDATE_POST_STORE':
            return {
                ...state,
                ...{
                    updatePostPending: false,
                    updatePostRes: null,
                    updatePostError: null,
                },
            };
        case 'HANDLE_CLEAR_DELETE_POST_STORE':
            return {
                ...state,
                ...{

                    deletePostPending: false,
                    deletePostRes: null,
                    deletePostError: null,
                },
            };
        case 'HANDLE_CLEAR_GET_ALL_POST_LIST_STORE':
            return {
                ...state,
                ...{
                    getAllPostPending: false,
                    getAllPostRes: null,
                    getAllPostError: null,
                },
            };
        case 'HANDLE_CLEAR_POST_COMMENT_STORE':
            return {
                ...state,
                ...{
                    postCommentPending: false,
                    postCommentRes: null,
                    postCommentError: null,
                },
            };
        case 'HANDLE_CLEAR_UPDATE_COMMENT_STORE':
            return {
                ...state,
                ...{
                    updateCommentPending: false,
                    updateCommentRes: null,
                    updateCommentError: null,
                },
            };
        case 'HANDLE_CLEAR_DELETE_COMMENT_STORE':
            return {
                ...state,
                ...{
                    deleteCommentPending: false,
                    deleteCommentRes: null,
                    deleteCommentError: null,
                },
            };
        case 'HANDLE_CLEAR_ADD_ANNOUNCEMENT_STORE':
            return {
                ...state,
                ...{
                    addAnnouncementPending: false,
                    addAnnouncementRes: null,
                    addAnnouncementError: null,
                },
            };
        case 'HANDLE_CLEAR_UPDATE_ANNOUNCEMENT_STORE':
            return {
                ...state,
                ...{
                    updateAnnouncementPending: false,
                    updateAnnouncementRes: null,
                    updateAnnouncementError: null,
                },
            };
        case 'HANDLE_CLEAR_DELETE_ANNOUNCEMENT_STORE':
            return {
                ...state,
                ...{
                    deleteAnnouncementPending: false,
                    deleteAnnouncementRes: null,
                    deleteAnnouncementError: null,
                },
            };
        default:
            return state;
    }
};

export default createReducer(
    {
        [actions.createPostRequest]: handleCreatePostRequest,
        [actions.createPostSuccess]: handleCreatePostSuccess,
        [actions.createPostError]: handleCreatePostError,

        [actions.updatePostRequest]: handleUpdatePostRequest,
        [actions.updatePostSuccess]: handleUpdatePostSuccess,
        [actions.updatePostError]: handleUpdatePostError,

        [actions.deletePostRequest]: handleDeletePostRequest,
        [actions.deletePostSuccess]: handleDeletePostSuccess,
        [actions.deletePostError]: handleDeletePostError,

        [actions.getAllPostRequest]: handleGetAllPostRequest,
        [actions.getAllPostSuccess]: handleGetAllPostSuccess,
        [actions.getAllPostError]: handleGetAllPostPostError,

        [actions.postLikeRequest]: handlePostLikeRequest,
        [actions.postLikeSuccess]: handlePostLikeSuccess,
        [actions.postLikeError]: handlePostLikeError,

        [actions.postLikeByIdRequest]: handleGetLikeByIdRequest,
        [actions.postLikeByIdSuccess]: handleGetLikeByIdSuccess,
        [actions.postLikeByIdError]: handleGetLikeByIdError,

        [actions.postCommentRequest]: handlePostCommentRequest,
        [actions.postCommentSuccess]: handlePostCommentSuccess,
        [actions.postCommentError]: handlePostCommentError,

        [actions.postCommentByIdRequest]: handleGetCommentByIdRequest,
        [actions.postCommentByIdSuccess]: handleGetCommentByIdSuccess,
        [actions.postCommentByIdError]: handleGetCommentByIdError,

        [actions.deleteCommentRequest]: handleDeleteCommentRequest,
        [actions.deleteCommentSuccess]: handleDeleteCommentSuccess,
        [actions.deleteCommentError]: handleDeleteCommentError,

        [actions.updateCommentRequest]: handleUpdateCommentRequest,
        [actions.updateCommentSuccess]: handleUpdateCommentSuccess,
        [actions.updateCommentError]: handleUpdateCommentError,

        [actions.getPostRequest]: handleGetPostRequest,
        [actions.getPostSuccess]: handleGetPostSuccess,
        [actions.getPostError]: handleGetPostError,

        [actions.getPostCountsRequest]: handleGetPostCountsRequest,
        [actions.getPostCountsSuccess]: handleGetPostCountsSuccess,
        [actions.getPostCountsError]: handleGetPostCountsError,

        [actions.addAnnouncementRequest]: handleAddAnnouncementRequest,
        [actions.addAnnouncementSuccess]: handleAddAnnouncementSuccess,
        [actions.addAnnouncementError]: handleAddAnnouncementError,

        [actions.getAnnouncementRequest]: handleGetAnnouncementRequest,
        [actions.getAnnouncementSuccess]: handleGetAnnouncementSuccess,
        [actions.getAnnouncementError]: handleGetAnnouncementError,

        [actions.updateAnnouncementRequest]: handleUpdateAnnouncementRequest,
        [actions.updateAnnouncementSuccess]: handleUpdateAnnouncementSuccess,
        [actions.updateAnnouncementError]: handleUpdateAnnouncementError,

        [actions.deleteAnnouncementRequest]: handleDeleteAnnouncementRequest,
        [actions.deleteAnnouncementSuccess]: handleDeleteAnnouncementSuccess,
        [actions.deleteAnnouncementError]: handleDeleteAnnouncementError,

        [actions.getPopUpAnnouncementRequest]: handleGetPopUpAnnouncementRequest,
        [actions.getPopUpAnnouncementSuccess]: handleGetPopUpAnnouncementSuccess,
        [actions.getPopUpAnnouncementError]: handleGetPopUpAnnouncementError,

        [actions.getWebcastRequest]: handleGetWebcastRequest,
        [actions.getWebcastSuccess]: handleGetWebcastSuccess,
        [actions.getWebcastError]: handleGetWebcastError,


        [actions.getAllAnnouncementRequest]: handleGetAllAnnouncementRequest,
        [actions.getAllAnnouncementSuccess]: handleGetAllAnnouncementSuccess,
        [actions.getAllAnnouncementError]: handleGetAllAnnouncementError,

        [actions.getAlertAnnouncementRequest]: handleGetAlertAnnouncementRequest,
        [actions.getAlertAnnouncementSuccess]: handleGetAlertAnnouncementSuccess,
        [actions.getAlertAnnouncementError]: handleGetAlertAnnouncementError,


        [actions.handleClearCommunityStore]: clearCommunityStore,


    },
    initialState,
);